/* §103 MAC stud kit add-on prompt (preview). Delegated click handler for [data-mac-skp-add]: POST /cart/add.js with the
   variant and quantity rendered by snippets/mac-studkit-prompt.liquid, then reload the cart page, or re-render the drawer
   (theme's cart:refresh) so the prompt disappears. The theme.liquid gift sync ignores stud kit lines (no _sku props). */
(function(){
  'use strict';
  if (window.MacStudKitPrompt) return; window.MacStudKitPrompt = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-mac-skp-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled) return;
    var box = b.closest('[data-mac-skp]'), msg = box && box.querySelector('.mac-skp__msg');
    var id = Number(b.getAttribute('data-variant-id')), qty = Number(b.getAttribute('data-qty'));
    if (!(id > 0) || !(qty > 0)) return;
    var props = {}; var forSku = b.getAttribute('data-for'); if (forSku) props['_Stud Kit For'] = forSku; if (b.getAttribute('data-unit') === 'single') props['_Stud unit'] = 'single';
    b.disabled = true; var label = b.textContent; b.textContent = 'Adding\u2026';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty, properties: props }] }) })
      .then(function(r){ if (!r.ok) return r.json().then(function(j){ throw j; }); return r.json(); })
      .then(function(){
        var where = box ? box.getAttribute('data-mac-skp-where') : '';
        if (where === 'page' || /^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })['catch'](function(err){
        b.disabled = false; b.textContent = label;
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Sorry, the stud kit could not be added. Please try again.';
      });
  }, true);
})();
